import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { FilterComponentModel } from 'src/app/models/filter-component.model';

@Component ({
    selector: 'app-checkbox-filter',
    templateUrl: './checkbox-filter.component.html',
    styleUrls: [ './checkbox-filter.component.scss' ],
})

export class CheckBoxFilterComponent implements OnInit {
    @Input('filter') filter: FilterComponentModel = {
        field: '',
        title: '',
        open: false,
        values: [],
        displayAs: 'checkbox',
    };

    @Input('selected') selected: any[] = [];

    @Output() selectionEmmiter: EventEmitter<any> = new EventEmitter();
    
    allArray = ['All', 'No Preference'];
    includesAll = false;

    constructor(){}

    ngOnInit() {
        let allIndex = this.filter.values.findIndex((x: { name: string; }) => this.allArray.includes(x.name));
        this.includesAll = allIndex !== -1;
    }

    updateAll(selection: { id: number, name: string }) {
        if (!this.allArray.includes(selection.name)) {
            this.selected = this.selected.filter(x => !this.allArray.includes(x.name));
            return;
        }
        if (this.selected.includes(selection)) this.selected = [ selection ];
    }

    emitContents(selection: { id: number, name: string }): void {
        if (this.includesAll) this.updateAll(selection);
        this.selectionEmmiter.emit({ filter: this.filter, selected: this.selected, selection });
    }

    isNan(value: string | number) {
      return isNaN(value as number);
    }
}
